import { Link, useNavigate } from 'react-router-dom'
import { Lock } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'

export default function Forbidden() {
  const { logout } = useAuth()
  const navigate = useNavigate()

  // UX-044: the user is still signed in, so a plain link to /login bounced
  // straight back to Home. End the session first, then go to /login.
  const signInDifferent = () => logout({ navigate: () => navigate('/login', { replace: true }) })

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-br from-sky-50 via-white to-[#E8EFF4]">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl border border-[rgba(12,74,110,0.12)] shadow-xl p-8 text-center">
          <div className="mx-auto mb-6 w-16 h-16 rounded-full bg-iflow-50 flex items-center justify-center text-iflow-600">
            <Lock size={28} aria-hidden />
          </div>
          <h1 className="text-2xl font-semibold text-iflow-900 mb-2">Access restricted</h1>
          <p className="text-slate-600 mb-2">
            You don&apos;t have permission to view this page.
          </p>
          <p className="text-sm text-slate-500 mb-8">
            This area requires the <strong className="text-iflow-900">administrator</strong> role.
            Contact your administrator if you believe you should have access.
          </p>

          <Link
            to="/"
            className="inline-flex w-full items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-iflow-700 text-white text-sm font-medium hover:bg-iflow-800 transition-colors"
          >
            Back to Home
          </Link>
          <button
            type="button"
            onClick={signInDifferent}
            className="mt-3 inline-flex w-full items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-iflow-700 text-sm font-medium hover:bg-iflow-50 transition-colors"
          >
            Sign in with a different account
          </button>
        </div>
      </div>
    </div>
  )
}
